var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 30C21.5114 30 23.75 27.7614 23.75 25C23.75 22.2386 21.5114 20 18.75 20C15.9886 20 13.75 22.2386 13.75 25C13.75 27.7614 15.9886 30 18.75 30Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 30C30.1307 30 31.25 27.7614 31.25 25C31.25 22.2386 30.1307 20 28.75 20C27.3692 20 26.25 22.2386 26.25 25C26.25 27.7614 27.3692 30 28.75 30Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30C35.6904 30 36.25 27.7614 36.25 25C36.25 22.2386 35.6904 20 35 20C34.3096 20 33.75 22.2386 33.75 25C33.75 27.7614 34.3096 30 35 30Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a77f091f4ac44c5739bab4c0962522b2.svg";
export { ForwardRef as ReactComponent };